import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Box, Table } from 'edenred-ui';

import { getBenefitIcon } from '@epi-constants/benefitTypes';
import { getFrequencyLabel } from '@epi-pages/Beneficiaries/helpers/getFrequencyLabel';
import { IChangeGroupModalContent } from '@epi-models/pages/Beneficiaries';

export const ChangeGroupModalContent = ({
  selectedGroup
}: IChangeGroupModalContent) => {
  const { t } = useTranslation();
  const { sizeMedium, primaryBackColorLight, sizeExtraSmall } = useTheme();

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.Cell>
            {t(
              'containers.beneficiaries.table.change_group_modal.table_header'
            )}
          </Table.Cell>
          <Table.Cell>
            {t(
              'containers.beneficiaries.table.change_group_modal.table_amount'
            )}
          </Table.Cell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {selectedGroup?.benefitSettings.map(benefit => (
          <Table.Row key={benefit.benefitType}>
            <Table.Cell>
              <Box display="flex" alignItems="center" gap={1}>
                {getBenefitIcon(t, benefit.benefitType, primaryBackColorLight)}
                <Box fontSize={sizeMedium}>
                  {t(
                    `components.manage_benefits.new.benefits.${benefit.benefitType.toLowerCase()}`
                  )}
                </Box>
              </Box>
            </Table.Cell>
            <Table.Cell>
              <Box display="flex" alignItems="center" gap={0.5}>
                {benefit.maxAmountPerPeriod} €
                <Box fontSize={sizeExtraSmall}>
                  ({getFrequencyLabel(benefit.benefitType)})
                </Box>
              </Box>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};
